import quicklinksStyles from './quicklinks';

toggleDropdown();
function toggleDropdown() {
  const menus = document.querySelectorAll(".quicklinks-bar__links");
  [...menus].map(menu => {
    menu.addEventListener('click', () => {
      if (window.matchMedia('(max-width:767px)').matches === !0) {
        menu.classList.toggle("opened")
      }
    })
  })
}
